import React from 'react';
import './AppToolString.css';

// Helper functions for escaping strings
function escapeForDoubleQuotes(s) {
  return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

function escapeForSingleQuotes(s) {
  return s.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
}

class AppToolString extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      originalString: "",
      outputString: "",
      error: null,
      copySuccess: '',
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleUnescape = this.handleUnescape.bind(this);
    this.handleEscapeSingle = this.handleEscapeSingle.bind(this);
    this.handleEscapeDouble = this.handleEscapeDouble.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  handleChange(e){
    const str = e.target.value;
    this.setState({
      originalString: str,
      outputString: "",
      error: null,
      copySuccess: ''
    });
  }

  handleUnescape() {
    let str = this.state.originalString;
    try {
      // Check if string is wrapped in quotes and remove them
      if ((str.startsWith("'") && str.endsWith("'")) || 
          (str.startsWith('"') && str.endsWith('"'))) {
        str = str.slice(1, -1);
      }
      
      // A simple unescape for common sequences.
      const unescaped = str
        .replace(/\\n/g, '\n')
        .replace(/\\r/g, '\r')
        .replace(/\\t/g, '\t')
        .replace(/\'/g, "'")
        .replace(/\\"/g, '"')
        .replace(/\\\\/g, '\\'); // Must be last
      this.setState({ outputString: unescaped, error: null });
    } catch (e) {
      this.setState({ error: '执行转义失败: ' + e.message, outputString: '' });
    }
  }

  handleEscapeSingle() {
    const str = this.state.originalString;
    const escaped = escapeForSingleQuotes(str);
    this.setState({ outputString: `'${escaped}'`, error: null });
  }

  handleEscapeDouble() {
    const str = this.state.originalString;
    const escaped = escapeForDoubleQuotes(str);
    this.setState({ outputString: `"${escaped}"`, error: null });
  }

  copyToClipboard() {
    if (!this.state.outputString) return;
    navigator.clipboard.writeText(this.state.outputString).then(() => {
      this.setState({ copySuccess: 'Copied!' });
      setTimeout(() => this.setState({ copySuccess: '' }), 2000);
    }, () => {
      this.setState({ copySuccess: 'Failed to copy!' });
      setTimeout(() => this.setState({ copySuccess: '' }), 2000);
    });
  }

  render() {
    const { originalString, outputString, error, copySuccess } = this.state;

    return (
      <div id="tool_string">
        <div id="content_box">
          <textarea 
              rows="8" 
              placeholder='请输入需要转义或反转义的字符串内容...'
              onChange={this.handleChange}
              value={originalString}
          ></textarea>

          <div className="toolbar">
            <button onClick={this.handleUnescape}>执行转义</button>
            <button onClick={this.handleEscapeSingle}>添加单引号转义</button>
            <button onClick={this.handleEscapeDouble}>添加双引号转义</button>
          </div>

          {(outputString || error) && (
            <div>
              {error ? (
                <pre className="error-message">{error}</pre>
              ) : (
                <div>
                  <div className="toolbar">
                    <button onClick={this.copyToClipboard}>Copy</button>
                    {copySuccess && <span className="copy-success">{copySuccess}</span>}
                  </div>
                  <textarea 
                    readOnly
                    rows="8"
                    value={outputString}
                    className="output-area"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AppToolString;
